import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';

import backgroundImage from '../assets/images/stage-select/bg.png'
import stage1Btn from '../assets/images/stage-select/btn-stage1.png'
import stage2Btn from '../assets/images/stage-select/btn-stage2.png'
import stage1BtnPressed from '../assets/images/stage-select/btn-stage1-pressed.png'
import stage2BtnPressed from '../assets/images/stage-select/btn-stage2-pressed.png'
import confirm from '../assets/images/stage-select/confirm.png';

class StageSelect extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            stage1Image: stage1Btn,
            stage2Image: stage2BtnPressed,
            selectedIndex: 1
        };
    }

    goToDescPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './desc',
            state: {
                stageIndex: this.state.selectedIndex,
                droneIndex: this.props.location.state.selectedIndex
            }
        });
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    onImageClicked(index) {
        this.playBtnSound()
        this.setState({
            stage1Image: index === 0 ? stage1BtnPressed : stage1Btn,
            stage2Image: index === 1 ? stage2BtnPressed : stage2Btn,
            selectedIndex: index
        });
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img className='press-btn' alt='' src={this.state.stage2Image} style={{ height: '40%', bottom: '27%', left: '28%', position: 'absolute', background: 'transparent' }} onClick={() => this.onImageClicked(1)}/>
                <img className='press-btn' alt='' src={this.state.stage1Image} style={{ height: '40%', bottom: '27%', right: '28%', position: 'absolute', background: 'transparent' }} onClick={() => this.onImageClicked(0)}/>
                <img className='press-btn' alt='' src={confirm} style={{ width: '19%', position: 'absolute', left: '40%', bottom: '8%' }} onClick={this.goToDescPage.bind(this)}></img>
            </div>
        )
    }
}

export default withRouter(StageSelect);
